import { useTranslation } from 'react-i18next';

import { Button } from '../../../atoms/button/button';
import { Card } from '../../../atoms/card/card';
import { Header } from '../../../atoms/header/header';
import { Text } from '../../../atoms/text/text';

interface ForgotPasswordSuccessFormProps {
  readonly onReturnToLogin: () => void;
}

const ForgotPasswordSuccessForm = ({ onReturnToLogin }: ForgotPasswordSuccessFormProps) => {
  const { t } = useTranslation();

  return (
    <div className="form-container">
      <Card className="p-8 text-center space-y-6">
        <Header level="h1">{t('auth.forgotPasswordSuccess.title')}</Header>
        <Text>{t('auth.forgotPasswordSuccess.description')}</Text>
        <Button className="w-full mt-8" onClick={onReturnToLogin}>
          {t('auth.forgotPasswordSuccess.returnButton')}
        </Button>
      </Card>
    </div>
  );
};

export { ForgotPasswordSuccessForm };
